import React from 'react'
import { Outlet } from 'react-router-dom'
import "./../../../Pages/ExtractData/extrac.css"

const ExtractSearch = () => {
  return (
    <div>
        <Outlet />
    </div>
  )
}

export default ExtractSearch
